module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVBAMAAABbObilAAAAAXNSR0IB2cksfwAAACpQTFRFAAAA////////////////////////////////////////////////////hrvKLwAAAA50Uk5TAHh3XzcQgD9nCEBoOGB4CGBTAAAAhUlEQVR4nGNgAAFGZVcGGGBLSysAM1idlYDsjAkg9rK0NCA7rQHInJEGYWcB2dug7LQABq40GPsAQxicfYHhGJytwHANRDGCCAEGMRAFtTINBhQYIOIQJRD1EGMg5kCMh5gPsRZiL9Q5YPcAwQYQezaYmQ12Psj9aWkLILaxnhWTPQpiAACN40Q7phPXIgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/side-menu--icon--alerts-analytics-unselected.png
// module id = 917
// module chunks = 0